import React from 'react';
import { MessageSquare, Users, ChevronRight } from 'lucide-react';

const WhatsAppCommunityBanner = ({ link = "https://chat.whatsapp.com/LwFGWhGmGfX82mOky3pqBK" }) => {
  return (
    <div className="my-8 rounded-xl overflow-hidden shadow-lg transform transition-all hover:shadow-xl">
      <div className="bg-gradient-to-r from-green-500 to-green-600 p-1">
        <div className="bg-white rounded-lg">
          <div className="grid md:grid-cols-5">
            <div className="bg-green-50 p-4 flex flex-col items-center justify-center text-center">
              <div className="bg-green-500 rounded-full p-3 mb-2">
                <MessageSquare size={28} className="text-white" />
              </div>
              <h3 className="font-semibold text-green-700">WhatsApp Community</h3>
            </div>
            
            {/* Content section - takes 4/5 on desktop */}
            <div className="md:col-span-4 p-6 flex flex-col md:flex-row items-center justify-between">
              <div className="mb-4 md:mb-0 text-center md:text-left">
                <div className="flex items-center mb-2">
                  <Users size={20} className="text-green-600 mr-2" />
                  <span className="text-sm font-medium text-green-700">Free Support Group</span>
                </div>
                <h4 className="text-lg md:text-xl font-medium text-gray-800 mb-2">
                  Join our supportive WhatsApp community
                </h4>
                <p className="text-gray-600 text-sm md:text-base">
                  Connect with others on similar healing journeys, share experiences, and receive additional support.
                </p>
              </div>
              
              <a 
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center bg-green-600 hover:bg-green-700 text-white py-3 px-6 rounded-lg font-medium transition-colors duration-300"
              >
                Join Community
                <ChevronRight size={18} className="ml-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatsAppCommunityBanner;